<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   width="24"
   height="24"
   viewBox="0 0 24 24"
   version="1.1"
   id="svg86"
   sodipodi:docname="arrow-up-small.svg"
   inkscape:version="1.0.2 (e86c870879, 2021-01-15, custom)">
  <metadata
     id="metadata92">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <defs
     id="defs90" />
  <sodipodi:namedview
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1"
     objecttolerance="10"
     gridtolerance="10"
     guidetolerance="10"
     inkscape:pageopacity="0"
     inkscape:pageshadow="2"
     inkscape:window-width="2546"
     inkscape:window-height="1404"
     id="namedview88"
     showgrid="false"
     inkscape:zoom="35.591041"
     inkscape:cx="11.119453"
     inkscape:cy="11.44863"
     inkscape:window-x="1924"
     inkscape:window-y="25"
     inkscape:window-maximized="0"
     inkscape:current-layer="svg86" />
  <path
     fill-rule="evenodd"
     clip-rule="evenodd"
     d="m 15.7929,14.957085 c 0.3905,0.39052 1.0237,0.39052 1.4142,0 0.3905,-0.39053 0.3905,-1.02371 0,-1.41421 l -4.5,-4.5 c -0.3905,-0.3905 -1.0237,-0.3905 -1.4142,0 l -4.50001,4.5 c -0.39052,0.3905 -0.39052,1.02368 0,1.41421 0.39053,0.39052 1.02369,0.39052 1.41422,0 L 12,11.164175 Z"
     fill="#000000"
     id="path84" />
</svg>
